import { nanoid } from 'nanoid';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { getActiveObesForCustomer } from 'api/obes/getObesForCustomer';
import { AutocompleteAsync, FormElement } from 'components/Form';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import useTransferTag from 'hooks/tags/useTransferTag';
import checkLoadable from 'utils/recoil/checkLoadable';
import FromTag from '../FromTag/FromTag';
const idSuffix = nanoid();
export default function ChooseTag() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const {
    tagNumber
  } = useParams();
  const {
    tag,
    setTag,
    resetTransferTag
  } = useTransferTag();
  const obesLoadable = useRecoilValueLoadable(getActiveObesForCustomer(customer?.id));
  const {
    contents: obes,
    loading
  } = checkLoadable(obesLoadable);
  const initialValue = obes?.find(obe => obe.obeNumber === tagNumber);
  useEffect(() => {
    resetTransferTag();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (initialValue) setTag(initialValue);
  }, [initialValue, setTag]);
  const onChange = async (_event, value) => {
    setTag(value);
  };
  const autocompleteInputId = `choose_tag_autocomplete_${idSuffix}`;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormElement, {
    title: t('transfer_tag.choose_tag_or_vehicle_title'),
    childId: autocompleteInputId
  }, /*#__PURE__*/React.createElement(AutocompleteAsync, {
    isLoading: loading,
    options: obes ?? [],
    placeholder: t('transfer_tag.choose_tag_or_vehicle'),
    optionLabel: ['registrationNumber', 'obeNumber'],
    onChange: onChange,
    value: initialValue || undefined,
    inputId: autocompleteInputId
  })), tag && /*#__PURE__*/React.createElement(FromTag, null));
}